import { genericPage, getMappingProgramaSlug, isCr, getServerSidePropsHelper } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
// /nom-bonic-programa/noticies/
const pathTv = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'noticies'];
const pathRadio = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'noticies-radio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS, 'programa', 'noticies']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    const path = isCr(mapping) ? pathRadio : pathTv;

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
